import { useSyncExternalStore } from "react";

// The globally selected cost-recognition basis (cost-recognition basis layer,
// U7). Like the date-range lens, it lives in localStorage so route loaders can
// read it when building query variables; the sidebar switcher writes it and
// invalidates the router. CASH is the default and the canonical raw material;
// NORMALIZED re-displays the same cash on the smoothed (terminal) basis. Only the
// pure cost screens (P&L, CAC, the overview cost tree) honor it.
export type Basis = "CASH" | "NORMALIZED";

const KEY = "cxcash.basis";
const DEFAULT: Basis = "CASH";
const VALUES: Basis[] = ["CASH", "NORMALIZED"];

export const BASIS_LABELS: Record<Basis, string> = {
  CASH: "Cash",
  NORMALIZED: "Normalized",
};

const listeners = new Set<() => void>();

export function getBasis(): Basis {
  const stored = localStorage.getItem(KEY);
  return VALUES.includes(stored as Basis) ? (stored as Basis) : DEFAULT;
}

export function setBasis(value: Basis) {
  localStorage.setItem(KEY, value);
  for (const listener of listeners) listener();
}

export function useBasis(): Basis {
  return useSyncExternalStore(
    (callback) => {
      listeners.add(callback);
      return () => listeners.delete(callback);
    },
    () => getBasis()
  );
}

// The query variable for a basis, or null for CASH — the default, omitted so a
// cash query is byte-identical to one sent before the basis argument existed.
export function basisParam(value: Basis): "NORMALIZED" | null {
  return value === "NORMALIZED" ? "NORMALIZED" : null;
}
